"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileChips = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var useDownload_1 = require("../../hooks/useDownload");
var styles_1 = __importDefault(require("./styles"));
/**
 * "Inner" Component for FileChips
 */
exports.FileChips = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, _b = _a.existingFiles, existingFiles = _b === void 0 ? [] : _b, editable = _a.editable, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, _d = _a.onFileClick, onFileClick = _d === void 0 ? function () { } : _d;
    var classes = (0, styles_1.default)();
    var download = (0, useDownload_1.useDownload)().download;
    var _e = (0, react_1.useState)(existingFiles || []), files = _e[0], setFiles = _e[1];
    (0, react_1.useEffect)(function () {
        setFiles(existingFiles);
    }, [existingFiles]);
    // handle click, sending the whole object back
    var handleFileClick = (0, react_1.useCallback)(function (index) {
        var file = files[index];
        if (file.original)
            download({
                href: file.originalSrc,
                filename: file.name
            });
        onFileClick(files[index]);
    }, [download, files, onFileClick]);
    // remove files/media from state by index
    var handleRemove = (0, react_1.useCallback)(function (index) {
        var copy = __spreadArray([], files, true);
        var file = copy[index];
        if (file.original) {
            // set as removed so we can track for later
            file.removed = true;
        }
        else {
            // otherwise remove any attachment
            copy.splice(index, 1);
        }
        setFiles(copy);
        onChange(copy);
    }, [files, onChange]);
    // sugar for different remove actions
    var handleRemoveFile = handleRemove;
    var fileChips = (0, react_1.useMemo)(function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.chipContainer }, { children: files.map(function (file, index) { return ((0, jsx_runtime_1.jsx)(core_1.Box
        // eslint-disable-next-line react/no-array-index-key
        , __assign({ style: { display: "".concat(file.removed ? 'none' : 'initial') } }, { children: !editable ? ((0, jsx_runtime_1.jsx)(core_1.Chip, { id: "".concat(idPrefix, "FileAttachmentButton"), classes: { label: classes.fileChiplabel, root: classes.fileChipRoot }, onClick: function () { return handleFileClick(index); }, label: file.name })) : ((0, jsx_runtime_1.jsx)(core_1.Chip, { id: "".concat(idPrefix, "FileAttachmentButton"), classes: {
                    label: classes.fileChiplabel,
                    root: classes.fileChipRoot,
                    deleteIcon: classes.fileChipDeleteIcon
                }, size: "small", label: file.name, onDelete: function () { return handleRemoveFile(index); }, deleteIcon: (0, jsx_runtime_1.jsx)(icons_1.Close, { color: "primary" }) })) }), "File".concat(file.name, "__").concat(index))); }) }))); }, [
        classes.chipContainer,
        classes.fileChiplabel,
        classes.fileChipRoot,
        classes.fileChipDeleteIcon,
        files,
        editable,
        idPrefix,
        handleFileClick,
        handleRemoveFile
    ]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Boolean(files.length) && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mt: 2, flexGrow: 1 }, { children: fileChips }))) }));
});
